import { SFormList } from 'shj-components'
import { useEffect, useState } from 'react'
import { Form, Input, message, Select } from 'antd'
import { argSave, argUpdateById } from '@/services/product.ts'
import { isEmpty } from 'lodash-es'
import { trimStr } from '@/utils/data.ts'

const AddOrEditConfigure = props => {
  const { editRef, argTypeEnum } = props
  const [form] = Form.useForm()

  const [type, setType] = useState('CHOOSE')

  useEffect(() => {
    form.resetFields()
    setType('CHOOSE')
    if (!isEmpty(props.record)) {
      const obj = { ...props.record }
      if (props.record.argType !== 'input') {
        obj.argValueJson = props.record.argValueJson?.list
      }
      form.setFieldsValue(obj)
      setType(props.record.argType)
    }
  }, [props.record])

  const onFinish = () => {
    form.validateFields().then(values => {
      props.setLoading?.(true)
      const argValueJson = values.argValueJson ? { list: values.argValueJson } : undefined
      const apiUrl = values.id ? argUpdateById : argSave
      apiUrl({ data: { ...values, argValueJson, argTypeFlag: 'define' } })
        .then((res: any) => {
          message.success(res.message || '操作成功')
          props.onCancel?.()
          props.fn?.()
        })
        .finally(() => props.setLoading?.(false))
    })
  }

  if (editRef) editRef.onFinish = onFinish

  const onRemove = (remove, filed) => {
    let value = form.getFieldValue(['argValueJson', filed.name])
    if (!value?.id) {
      const list = form.getFieldValue(['argValueJson']) || [];
      list.splice(filed.name, 1);
      form.setFieldValue(['argValueJson'], list);
    } else {
      message.warning('已保存数据不能删除')
    }
  }
  return (
    <>
      <Form
        style={{ maxHeight: 500, overflowY: 'auto' }}
        form={form}
        layout={'vertical'}
        initialValues={{ argType: 'CHOOSE', argValueJson: [{ value: '' }] }}
      >
        <Form.Item label={'id'} name={'id'} hidden>
          <Input />
        </Form.Item>
        <Form.Item label={'argCode'} name={'argCode'} hidden>
          <Input />
        </Form.Item>
        <Form.Item
          label={'参数名称'}
          name={'argName'}
          required={true}
          rules={[{ required: true, message: '参数名称不能为空' }]}
        >
          <Input
            placeholder={'请输入参数名称'}
            maxLength={15}
            showCount
            onChange={e => {
              form.setFieldValue('argName', trimStr(e.target.value))
            }}
          />
        </Form.Item>
        <Form.Item
          label={'参数类型'}
          name={'argType'}
          required={true}
          rules={[{ required: true, message: '参数类型不能为空' }]}
        >
          <Select
            fieldNames={{ value: 'key', label: 'description' }}
            disabled={props.record.id}
            onChange={v => setType(v)}
            options={argTypeEnum}
          />
        </Form.Item>
        {type === 'CHOOSE' && (
          <Form.Item label={'参数可选项'} required={true}>
            <SFormList
              onRemove={onRemove}
              name={'argValueJson'}
              addType={['icon']}
              leastOne={true}
              showMode={{ add: true }}
            >
              <Form.Item name={'id'} hidden>
                <Input />
              </Form.Item>
              <Form.Item
                name={'name'}
                style={{ flex: 1 }}
                rules={[{ required: true, message: '参数不能为空' }]}
              >
                <Input placeholder={'请输入参数可选项'} maxLength={50} showCount />
              </Form.Item>
            </SFormList>
          </Form.Item>
        )}
      </Form>
    </>
  )
}

export default AddOrEditConfigure
